import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router } from '@angular/router';
import { Observable } from 'rxjs-compat/Observable'
import { LabApiConfiguration } from '../apiConfiguration';
import { LookupCategory } from '../../../models/lab/lookup-category';
import { ServiceBase } from 'app/shared/infrastructure';
@Injectable()
export class LablookupCategoryService extends ServiceBase {

    private _actionUrl: string;
    private _url: string;

    constructor(private _http: HttpClient, private _configuration: LabApiConfiguration, private _router: Router) {
        super();
        this._actionUrl = _configuration.server;
        this._url = this._actionUrl + _configuration.lookupCategory.url;
    }

    getAll = (): Observable<LookupCategory[]> => {
        return this._http.get<any>(this._url);
    }

}
